<section id="content" class="content">
  <div class="content__boxed w-100 min-vh-100 d-flex flex-column align-items-center justify-content-center">
    @if (showMessage) {
      <div class="content__wrap">
        <div class="card shadow-lg">
          <div class="card-body">
            <div [ngClass]="isErrorMessage ? 'alert alert-danger' : 'alert alert-success'" role="alert">
              <h1 class="h3">
                @if (isErrorMessage && dialogType === redirectType.assignIdpUser) {
                  <div>
                    <i class="fa-solid fa-circle-x"></i>
                    {{'ERROR_LINKING_CONTRACT' | translation}}
                  </div>
                }
                @if (isErrorMessage && dialogType === redirectType.addContract) {
                  <div>
                    <i class="fa-solid fa-circle-x"></i>
                    {{'ERROR_ADDING_CONTRACT' | translation}}
                  </div>
                }
                @if (!isErrorMessage) {
                  <div>
                    <i class="fa-solid fa-circle-check"></i>
                    {{ textMessage }}
                  </div>
                }
              </h1>
            </div>
            @if (isErrorMessage) {
              <div class="text-center">
                <p>{{ textMessage }}</p>
              </div>
            }
            <div class="d-grid">
              @if (isGeneralError) {
                <button class="btn btn-primary btn-lg" (click)="tryAgain()">{{'TRY_AGAIN' | translation}}</button>
              } @else {
                <button class="btn btn-primary btn-lg" (click)="doReturn()">{{'BACK' | translation}}</button>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (showUserCredentials) {
      <div class="card shadow-lg">
        <div class="card-body" [hidden]="dialogType === redirectType.removeContract">
          <div class="text-center">
            @if (dialogType === redirectType.assignIdpUser) {
              <h1 class="h3">{{'LINK_CONTRACT' | translation}}</h1>
            }
            @if (dialogType === redirectType.addContract) {
              <h1 class="h3">{{'ADD_CONTRACT' | translation}}</h1>
            }
            @if (dialogType === redirectType.removeContract) {
              <h1 class="h3">{{'REMOVE_MITID_LINK' | translation}}</h1>
            }
            <p [hidden]="dialogType === redirectType.removeContract">{{'ENTER_USERNAME_PASSWORD' | translation}}</p>
          </div>
          <form class="mt-4" action="index.html">
            <div [hidden]="dialogType === redirectType.removeContract" class="mb-3">
              <input name="brugernavn" [(ngModel)]="username" type="text" class="form-control" [placeholder]="'USERNAME_PLACEHOLDER' | translation" autofocus>
            </div>
            <div [hidden]="dialogType === redirectType.removeContract" class="mb-3">
              <input name="password" [(ngModel)]="password" type="password" class="form-control" [placeholder]="'PASSWORD' | translation">
            </div>
            <div class="d-grid">
              <div class="d-grid mt-3">
                <button class="btn btn-primary btn-lg" (click)="onProcessContract('mitid')">{{'MITID' | translation}}</button>
              </div>
              <button class="mt-3 btn btn-primary buttom-0 endt-0" (click)="doReturn()">{{'BACK' | translation}}</button>
            </div>
          </form>
        </div>
      </div>
    }
    @if (showRemoveContract) {
      <div class="card shadow-lg">
        <div class="card-body">
          <div class="text-center">
            <h1 class="h3">{{'SELECT_UTILITIES' | translation}}</h1>
          </div>
          <table class="table table-hover" style="max-height: 400px; overflow-y: auto;">
            <tbody>
              @for (location of locationRemove; track location; let idx = $index) {
                <tr style="cursor: pointer;">
                  <td>
                    <input type="checkbox" (click)="onChooseRemove(location, $event)">&nbsp;&nbsp;<label>{{ location.utilityName}}:</label>
                    <br>
                      @for (places of location.locations; track places) {
                        <span>
                          - {{ places.description }}<br>
                        </span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="d-grid">
              <div class="d-grid mt-3">
                <button class="btn btn-primary btn-lg" [disabled]="selectedContract.length <= 0" (click)="onRemoveContracts()">{{'UNSUBSCRIBE' | translation}}</button>
              </div>
              <button class="mt-3 btn btn-primary buttom-0 endt-0" (click)="doReturn()">{{'BACK' | translation}}</button>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
